// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"cedc1421","173":"db1711af","285":"1e00d94e","346":"1e206998","580":"204dc0e8","852":"08fbe4ed","877":"18c38742","951":"4860e956"}[chunkId] + ".chunk.js";
};